import React, { useEffect, useMemo, useRef, useState } from "react";
import commentary from "../../assets/images/commentary.png";
import casino from "../../assets/images/menu-99998.png";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useStore } from "react-redux";
import { Modal } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  fetchCasinoConversionRate,
  fetchGapCasinoGames,
  fetchQtechGames,
} from "../../store/slices/casinoSlice";
import { navigateToCasinoGameLaunch } from "../../utils/casinoLaunchNavigation";
import casinoPoint100 from "../../assets/images/casinopoint100.png";

const SUBCATEGORY_ICON_BASE = "https://speedcdn.io/assets/int_tab_icons";
const ALL_SUBCATEGORY = "ALL";
const STATIC_ALL_SUBCATEGORIES = [
  "Aviator X",
  "Chicken Games",
  "Mines",
  "Color game",
];

const MAINTABS = [
  { code: "MAC88", tabName: "ALL" },
  { code: "MAC88", tabName: "MAC Excite" },
  { code: "MAC88", tabName: "Fun Games" },
  { code: "MAC88", tabName: "Mac88 Gaming" },
  { code: "AURA", tabName: "Aura Gaming" },
  { code: "MAC88", tabName: "Mac88 Gaming Virtual" },
  {
    code: "JiLi",
    tabName: "JILI",
    provider: "JiLi",
    subProvider: "JiLi Gaming",
  },
  {
    code: "EVO",
    tabName: "EVOLUTION",
    provider: "DC",
    subProvider: "Evolution Gaming",
  },
  // { code: "NE", tabName: "NETENT", },
  {
    code: "TRB",
    tabName: "CRASH GAMES",
    provider: "CRASH88",
    subProvider: "CRASH88 Gaming",
  },
  // { code: "BBG", tabName: "SLOT GAMES" },
  { code: "SPB", tabName: "SPRIBE", provider: "SPRIBE", subProvider: "SPRIBE" },
  { code: "EZU", tabName: "EZUGI", provider: "EZUGI", subProvider: "Ezugi" },
  // { code: "PNG", tabName: "PLAY'N GO" },
  // { code: "RED", tabName: "RED TIGER" },
  {
    code: "EVP",
    tabName: "EVOPLAY",
    provider: "DC",
    subProvider: "Evoplay Entertainment",
  },
  // { code: "CQC", tabName: "CQ9 CASINO" },
  {
    code: "BPG",
    tabName: "BLUEPRINT GAMING",
    provider: "DC",
    subProvider: "Blueprint Gaming",
  },
  // { code: "YGG", tabName: "YGGDRASIL" },
  { code: "HAB", tabName: "HABANERO", provider: "DC", subProvider: "Habanero" },
  {
    code: "HAK",
    tabName: "HACKSAW GAMING",
    provider: "DC",
    subProvider: "Hacksaw Gaming",
  },
  // { code: "QS", tabName: "QUICKSPIN" },
  // { code: "GA", tabName: "GAMEART" },
  // { code: "DS", tabName: "DRAGONSOFT" },
  // { code: "RTG", tabName: "RTG SLOTS" },
  {
    code: "NLC",
    tabName: "NOLIMIT CITY",
    provider: "DC",
    subProvider: "Nolimit City",
  },
  { code: "OT", tabName: "ONETOUCH", provider: "DC", subProvider: "OneTouch" },
  // { code: "TK", tabName: "THUNDERKICK" },
  // { code: "MOB", tabName: "MOBILOTS" },
  // { code: "IDS", tabName: "IRON DOG STUDIO" },
  // { code: "1x2", tabName: "1X2 GAMING" },
  // { code: "BNG", tabName: "BOOONGO" },
  // { code: "MNP", tabName: "MANNA PLAY" },
  // { code: "TPG", tabName: "TRIPLE PG" },
  { code: "GZX", tabName: "GAMZIX", provider: "DC", subProvider: "Gamzix" },
  // { code: "SHS", tabName: "SPEARHEAD STUDIOS" },
  // { code: "PUG", tabName: "PUSH GAMING" },
  // { code: "NGE", tabName: "NETGAME ENTERTAINMENT" },
  // { code: "PP", tabName: "PLAYPEARLS" },
  // { code: "WOO", tabName: "WOOHOO GAMES" },
  // { code: "SM", tabName: "SLOTMILL" },
  {
    code: "AUX",
    tabName: "AVATAR UX",
    provider: "DC",
    subProvider: "AvatarUX",
  },
  {
    code: "BTG",
    tabName: "BIG TIME GAMING",
    provider: "DC",
    subProvider: "Big Time Gaming",
  },
  {
    code: "FNG",
    tabName: "FANTASMA GAMES",
    provider: "DC",
    subProvider: "Fantasma",
  },
  // { code: "RG", tabName: "REVOLVER GAMING" },
  // { code: "KIR", tabName: "KIRON INTERACTIVE" },
  // { code: "SAG", tabName: "SA GAMING" },
  { code: "FUG", tabName: "FUGASO", provider: "DC", subProvider: "Fugaso" },
  // { code: "PRS", tabName: "PRINT STUDIOS" },
  // { code: "BTL", tabName: "BETER LIVE" },
  // { code: "SWL", tabName: "SKYWIND LIVE" },
  {
    code: "BTV",
    tabName: "BETGAMES.TV",
    provider: "BETGAMES",
    subProvider: "BetGames",
  },
  {
    code: "SMS",
    tabName: "SMARTSOFT",
    provider: "DC",
    subProvider: "Smartsoft Gaming",
  },
  {
    code: "BTV",
    tabName: "BetGames TV",
    provider: "BETGAMES",
    subProvider: "BetGames",
  },
  {
    code: "TRB",
    tabName: "TURBO",
    provider: "TURBO",
    subProvider: "Turbo Games",
  },
  // { code: "SAG", tabName: "AE SEXY" },
  {
    code: "RG",
    tabName: "ROYAL GAMING",
    provider: "RG",
    subProvider: "Royal Gaming",
  },
  // { code: "GAP", tabName: "GAP" },
  { tabName: "Asia Gaming", provider: "DC", subProvider: "Asia Gaming" },
  { tabName: "BGaming", provider: "DC", subProvider: "BGaming" },
  {
    tabName: "Big Time Gaming",
    provider: "DC",
    subProvider: "Big Time Gaming",
  },
  {
    tabName: "Blueprint Gaming",
    provider: "DC",
    subProvider: "Blueprint Gaming",
  },
  { tabName: "Boldplay", provider: "DC", subProvider: "Boldplay" },
  { tabName: "Bombay Live", provider: "DC", subProvider: "Bombay Live" },
  { tabName: "Booming Games", provider: "DC", subProvider: "Booming Games" },
  { tabName: "Betsoft", provider: "DC", subProvider: "Betsoft" },
  { tabName: "Caleta Gaming", provider: "DC", subProvider: "Caleta Gaming" },
  { tabName: "Darwin Gaming", provider: "DC", subProvider: "Darwin Gaming" },
  { tabName: "Games Global", provider: "DC", subProvider: "Games Global" },
  { tabName: "Gametech", provider: "DC", subProvider: "Gametech" },
  { tabName: "Gamomat", provider: "DC", subProvider: "Gamomat" },
  { tabName: "Golden Race", provider: "DC", subProvider: "Golden Race" },
  { tabName: "ICONIC21", provider: "DC", subProvider: "ICONIC21" },
  { tabName: "JDB Gaming", provider: "DC", subProvider: "JDB Gaming" },
  { tabName: "Kalamba  Games", provider: "DC", subProvider: "Kalamba  Games" },
  { tabName: "Keno", provider: "DC", subProvider: "Keno" },
  { tabName: "Live88", provider: "DC", subProvider: "Live88" },
  {
    tabName: "Microgaming Live",
    provider: "DC",
    subProvider: "Microgaming Live",
  },
  { tabName: "Million Games", provider: "DC", subProvider: "Million Games" },
  { tabName: "OneTouch", provider: "DC", subProvider: "OneTouch" },
  { tabName: "Oryx Gaming", provider: "DC", subProvider: "Oryx Gaming" },
  { tabName: "PGSoft", provider: "DC", subProvider: "PGSoft" },
  { tabName: "PlayAce", provider: "DC", subProvider: "PlayAce" },
  { tabName: "Playson", provider: "DC", subProvider: "Playson" },
  { tabName: "Playtech", provider: "DC", subProvider: "Playtech" },
  { tabName: "Playtech Live", provider: "DC", subProvider: "Playtech Live" },
  { tabName: "Popok Instant", provider: "DC", subProvider: "Popok Instant" },
  { tabName: "Pragmatic Play", provider: "DC", subProvider: "Pragmatic Play" },
  {
    tabName: "Pragmatic Play 2",
    provider: "DC",
    subProvider: "Pragmatic Play 2",
  },
  {
    tabName: "Pragmatic Play Live",
    provider: "DC",
    subProvider: "Pragmatic Play Live",
  },
  { tabName: "Relax Gaming", provider: "DC", subProvider: "Relax Gaming" },
  { tabName: "Tangente", provider: "DC", subProvider: "Tangente" },
  { tabName: "TriStar", provider: "DC", subProvider: "TriStar" },
  { tabName: "TrueLab", provider: "DC", subProvider: "TrueLab" },
  { tabName: "TVBet", provider: "DC", subProvider: "TVBet" },
  { tabName: "Vivo Gaming", provider: "DC", subProvider: "Vivo Gaming" },
  { tabName: "VoltEnt", provider: "DC", subProvider: "VoltEnt" },
  { tabName: "Wazdan", provider: "DC", subProvider: "Wazdan" },
  { tabName: "WinFast", provider: "DC", subProvider: "WinFast" },
  { tabName: "Winfinity", provider: "DC", subProvider: "Winfinity" },
];

const searchKeywords = {
  "Aviator X": ["aviator", "jet"],
  "Chicken Games": ["chicken"],
  Mines: ["mines"],
  "Color game": ["color"],
};

const normalizeValue = (value) => (value || "").toString().trim().toLowerCase();
const normalizeCategoryKey = (value) =>
  (value || "")
    .toString()
    .toLowerCase()
    .replace(/\//g, " ")
    .replace(/[_-]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
const slugify = (str) =>
  normalizeValue(str)
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

function getCategoryDisplayLabel(category) {
  if (!category || typeof category !== "string") return category;
  const trimmed = category.trim();
  const lastSlash = trimmed.lastIndexOf("/");
  return lastSlash >= 0 ? trimmed.slice(lastSlash + 1) : trimmed;
}

function filterGamesByCategory(games, category, routeCategory) {
  const list = Array.isArray(games) ? games : [];
  if (!category || category === ALL_SUBCATEGORY) return list;

  if (normalizeValue(routeCategory) === "all") {
    const terms = searchKeywords?.[category] || [];
    if (!terms.length) return list;
    const match = (s) => {
      const str = normalizeValue(s);
      return terms.some((t) => str.includes(normalizeValue(t)));
    };
    return list.filter((g) => match(g?.gameName) || match(g?.category));
  }

  const selectedKey = normalizeCategoryKey(getCategoryDisplayLabel(category));
  return list.filter((g) => {
    const gameCatKey = normalizeCategoryKey(
      getCategoryDisplayLabel(g?.category),
    );
    if (gameCatKey && gameCatKey === selectedKey) return true;
    return Boolean(gameCatKey && gameCatKey.includes(selectedKey));
  });
}

const Casino = () => {
  const dispatch = useAppDispatch();
  const store = useStore();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState("");
  const routeCategory = searchParams.get("category");
  const routeSubCategory = searchParams.get("subCategory");

  const filterTabRefs = useRef([]);
  const allCategoryRef = useRef(null);
  const categoryStripRefs = useRef([]);

  const activeFilterIndex = useMemo(() => {
    const normalizedCategory = (routeCategory || "").toUpperCase().trim();
    if (!normalizedCategory) return 0;
    const index = MAINTABS.findIndex(
      (tab) => (tab.tabName || "").toUpperCase().trim() === normalizedCategory,
    );
    return index >= 0 ? index : 0;
  }, [routeCategory]);

  const activeProviderCode = MAINTABS[activeFilterIndex]?.code || "MAC88";
  const gapGamesByProvider = useAppSelector(
    (state) => state.casino?.gapGamesByProvider || {},
  );
  const loading = useAppSelector((state) => state.casino?.loading || false);
  const casinoConversionRate = useAppSelector(
    (state) => state.casino?.casinoConversionRate,
  );

  const auth = useAppSelector((state) => state.auth);
  const [dismissedConversionRateDialog, setDismissedConversionRateDialog] =
    useState(false);
  const apiGames =
    gapGamesByProvider[
      MAINTABS[activeFilterIndex]?.provider
        ? MAINTABS[activeFilterIndex]?.tabName
        : activeProviderCode
    ] || [];

  useEffect(() => {
    dispatch(fetchCasinoConversionRate());
  }, [dispatch]);

  const conversionRateValue =
    casinoConversionRate?.data?.casino_conversion_rate;
  const shouldShowConversionRateDialog = conversionRateValue === 10;

  useEffect(() => {
    const providerCode = MAINTABS[activeFilterIndex]?.code;
    const requestKey = MAINTABS[activeFilterIndex]?.provider
      ? MAINTABS[activeFilterIndex]?.tabName
      : providerCode;
    const providerName = MAINTABS[activeFilterIndex]?.provider;
    const subProviderName = MAINTABS[activeFilterIndex]?.subProvider;

    if (!requestKey) return;
    const casinoState = store.getState().casino;
    const games = casinoState.gapGamesByProvider[providerCode];
    if (Array.isArray(games)) return;
    if (casino.loading) return;
    dispatch(
      fetchGapCasinoGames({
        providerName: providerName || providerCode,
        subProviderName,
        page: 1,
        requestKey,
      }),
    );
  }, [activeFilterIndex, dispatch, store]);

  const selectedMainCategoryName =
    MAINTABS[activeFilterIndex]?.tabName || "ALL";

  const gamesByProvider = useMemo(() => {
    let list = Array.isArray(apiGames) ? apiGames : [];
    const selectedTabNorm = normalizeValue(selectedMainCategoryName);
    if (
      activeProviderCode === "MAC88" &&
      selectedTabNorm &&
      selectedTabNorm !== normalizeValue("ALL")
    ) {
      list = list.filter((g) => {
        const subProvider =
          g?.subProviderName ??
          g?.sub_provider_name ??
          g?.subProvider ??
          g?.sub_provider ??
          "";
        return normalizeValue(subProvider) === selectedTabNorm;
      });
    }
    return list;
  }, [apiGames, activeProviderCode, selectedMainCategoryName]);

  const selectedSubCategory = routeSubCategory || "";

  const categoryStripList = useMemo(() => {
    if (normalizeValue(selectedMainCategoryName) === "all") {
      return STATIC_ALL_SUBCATEGORIES;
    }
    const byKey = new Map();
    for (const g of gamesByProvider) {
      const c = (g.category || "").trim();
      if (!c) continue;
      const key = c.toLowerCase();
      if (!byKey.has(key)) byKey.set(key, c);
    }
    return Array.from(byKey.values());
  }, [gamesByProvider, selectedMainCategoryName]);

  useEffect(() => {
    if (!categoryStripList.length) return;
    const hasSubCategory = categoryStripList.some(
      (item) => normalizeValue(item) === normalizeValue(selectedSubCategory),
    );
    if (hasSubCategory) return;
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      const defaultSubCategory =
        normalizeValue(selectedMainCategoryName) === "all"
          ? STATIC_ALL_SUBCATEGORIES[0]
          : ALL_SUBCATEGORY;
      next.set("subCategory", defaultSubCategory);
      return next;
    });
  }, [
    categoryStripList,
    selectedMainCategoryName,
    selectedSubCategory,
    setSearchParams,
  ]);

  useEffect(() => {
    const hasValidRouteCategory =
      !!routeCategory &&
      MAINTABS.some(
        (tab) =>
          (tab.tabName || "").toUpperCase().trim() ===
          (routeCategory || "").toUpperCase().trim(),
      );
    if (hasValidRouteCategory) return;
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set("category", "ALL");
      next.set("providerCode", "MAC88");
      if (!next.get("subCategory")) {
        next.set("subCategory", STATIC_ALL_SUBCATEGORIES[0]);
      }
      return next;
    });
  }, [routeCategory, setSearchParams]);

  const displayedGames = useMemo(() => {
    let list = filterGamesByCategory(
      gamesByProvider,
      selectedSubCategory || ALL_SUBCATEGORY,
      routeCategory,
    );
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase().trim();
      list = list.filter((g) => (g.gameName || "").toLowerCase().includes(q));
    }
    return list;
  }, [gamesByProvider, searchQuery, selectedSubCategory, routeCategory]);

  const handleMainTab = (index) => {
    const selectedTab = MAINTABS[index];
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set("providerCode", selectedTab?.code || "MAC88");
      next.set("category", selectedTab?.tabName || "ALL");
      next.set(
        "subCategory",
        normalizeValue(selectedTab?.tabName || "ALL") === "all"
          ? STATIC_ALL_SUBCATEGORIES[0]
          : ALL_SUBCATEGORY,
      );
      return next;
    });
    filterTabRefs.current[index]?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });
  };

  const handleGameClick = (game) => {
    navigateToCasinoGameLaunch(
      navigate,
      game,
      {
        activeProviderCode,
        selectedSubCategory,
      },
      auth,
    );
  };

  return (
    <section className="section listing_page">
      <Modal
        show={shouldShowConversionRateDialog && !dismissedConversionRateDialog}
        onHide={() => setDismissedConversionRateDialog(true)}
        centered
        className="engcasinomodalbgimg_main"
      >
        <div className="engcasinomodalbgimg">
          <button
            type="button"
            onClick={() => setDismissedConversionRateDialog(true)}
            className="close"
            aria-label="Close"
          >
            ×
          </button>

          <img alt="" className="img-fluid" src={casinoPoint100} />
          <h2 className="lobby">1 POINT = {conversionRateValue}</h2>
          <p className="maximum_bet">2,00,000</p>
          <button
            type="button"
            className="virtual-close-btn"
            onClick={() => {
              setDismissedConversionRateDialog(true);
            }}
          >
            &nbsp;
          </button>
        </div>
      </Modal>
      <div className="row">
        <div className="col-12 d-flex">
          <div className="commentary">
            <img src={commentary} alt="commentary" />
            <div className="commentary-ticker" aria-live="polite">
              <span>
                🏆𝐈𝐂𝐂 𝐌𝐄𝐍'𝐒 𝐓𝟐𝟎 𝐖𝐎𝐑𝐋𝐃 𝐂𝐔𝐏 𝟐𝟎𝟐𝟔🏆 𝐂𝐔𝐏 𝐖𝐈𝐍𝐍𝐄𝐑 𝐁𝐄𝐓𝐒 𝐒𝐓𝐀𝐑𝐓𝐄𝐃 ⚽𝐔𝐄𝐅𝐀
                𝐂𝐇𝐀𝐌𝐏𝐈𝐎𝐍𝐒 𝐋𝐄𝐀𝐆𝐔𝐄 🏆 𝐂𝐔𝐏 𝐖𝐈𝐍𝐍𝐄𝐑 𝐁𝐄𝐓𝐒 𝐒𝐓𝐀𝐑𝐓𝐄𝐃 𝐈𝐍 𝐎𝐔𝐑 𝐄𝐗𝐂𝐇𝐀𝐍𝐆𝐄 ⚽
                🏏𝐏𝐋𝐀𝐘 𝐓𝐇𝐄 𝐆𝐄𝐍𝐈𝐄 𝐂𝐎𝐌𝐁𝐎 𝐒𝐏𝐄𝐂𝐈𝐀𝐋 𝐁𝐄𝐓 𝐈𝐍 𝐎𝐔𝐑 𝐄𝐗𝐂𝐇𝐀𝐍𝐆𝐄 𝐀𝐍𝐃 𝐌𝐔𝐋𝐓𝐈𝐏𝐋𝐘
                �𝐎𝐔𝐑 �𝐖𝐈𝐍𝐍𝐈𝐍𝐆𝐒 ,𝐎𝐔𝐑 𝐄𝐗𝐂𝐋𝐔𝐒𝐈𝐕𝐄 𝐏𝐑𝐄𝐌𝐈𝐔𝐌 𝐌𝐀𝐑𝐊𝐄𝐓 𝐅𝐎𝐑 (𝐒𝐑𝐋) 𝐈𝐒 𝐍𝐎𝐖
                𝐓𝐀𝐑𝐓𝐄𝐃 🏏 𝐃𝐑𝐄𝐀𝐌 𝐁𝐈𝐆 𝐖𝐈𝐍 𝐁𝐈𝐆 🏆
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-12 listing_page_12">
        <div className="middle-page-content home-page">
          <div className="game-slider mb-2">
            <div className="coupon-card">
              <div className="card">
                <div className="card-body card-content p-0">
                  <div className="bet-table-header">
                    <div className="row align-items-center g-0">
                      <div className="col-md-4">
                        <span className="list-sport-title">
                          <img
                            className="img-fluid game-icon-img"
                            src={casino}
                            alt="casino"
                          />
                          Casino
                        </span>
                      </div>
                      <div className="casino_searchbar">
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="Search Games..."
                            className="ng-untouched ng-pristine ng-valid"
                            aria-label="Search Games"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          />
                          <span className="input-group-text">
                            <i className="bi bi-search"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bet-table-body">
                    <div className="home-products-container mt-1">
                      <div className="row row5">
                        <div className="col-md-12">
                          <div className="casino_tabs_ul tab-container">
                            <ul
                              role="tablist"
                              className="nav nav-tab fancy-subtabs"
                              aria-label="Tabs"
                            >
                              {MAINTABS.map((tab, index) => (
                                <li
                                  key={tab?.tabName}
                                  ref={(el) =>
                                    (filterTabRefs.current[index] = el)
                                  }
                                  className={`nav-item${activeFilterIndex === index ? " active" : ""}`}
                                >
                                  <button
                                    type="button"
                                    role="tab"
                                    className={`nav-link${activeFilterIndex === index ? " active" : ""}`}
                                    aria-controls={`parentTab-${index}`}
                                    aria-selected={activeFilterIndex === index}
                                    id={`parentTab-${index}-link`}
                                    tabIndex={0}
                                    onClick={() => handleMainTab(index)}
                                    onKeyDown={(e) =>
                                      e.key === "Enter" && handleMainTab(index)
                                    }
                                  >
                                    <span />
                                    <span> {tab?.tabName} </span>
                                  </button>
                                </li>
                              ))}
                            </ul>
                            <div className="tab-content">
                              <div
                                id={`parentTab-${activeFilterIndex}`}
                                className="tab-pane active"
                              >
                                <div className="casino_tabs_ul tab-container">
                                  <ul className="nav nav-tab new_icasino_tabs mt-2">
                                    {!!activeFilterIndex && (
                                      <li
                                        ref={allCategoryRef}
                                        className={`nav-item${
                                          normalizeValue(
                                            selectedSubCategory ||
                                              ALL_SUBCATEGORY,
                                          ) === normalizeValue(ALL_SUBCATEGORY)
                                            ? " active"
                                            : ""
                                        }`}
                                      >
                                        <Link
                                          to="#"
                                          role="tab"
                                          tabIndex={0}
                                          className={`nav-link${
                                            normalizeValue(
                                              selectedSubCategory ||
                                                ALL_SUBCATEGORY,
                                            ) ===
                                            normalizeValue(ALL_SUBCATEGORY)
                                              ? " active"
                                              : ""
                                          }`}
                                          aria-controls="tab-all"
                                          aria-selected={
                                            normalizeValue(
                                              selectedSubCategory ||
                                                ALL_SUBCATEGORY,
                                            ) ===
                                            normalizeValue(ALL_SUBCATEGORY)
                                          }
                                          id="tab1-link"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setSearchParams((prev) => {
                                              const next = new URLSearchParams(
                                                prev,
                                              );
                                              next.set(
                                                "subCategory",
                                                ALL_SUBCATEGORY,
                                              );
                                              return next;
                                            });
                                            allCategoryRef.current?.scrollIntoView(
                                              {
                                                behavior: "smooth",
                                                block: "nearest",
                                                inline: "center",
                                              },
                                            );
                                          }}
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              e.preventDefault();
                                              setSearchParams((prev) => {
                                                const next =
                                                  new URLSearchParams(prev);
                                                next.set(
                                                  "subCategory",
                                                  ALL_SUBCATEGORY,
                                                );
                                                return next;
                                              });
                                              allCategoryRef.current?.scrollIntoView(
                                                {
                                                  behavior: "smooth",
                                                  block: "nearest",
                                                  inline: "center",
                                                },
                                              );
                                            }
                                          }}
                                        >
                                          <span></span>
                                          <span id="childTab-1-0">
                                            <img
                                              className="img-fluid"
                                              src="https://speedcdn.io/assets/int_tab_icons/all.png"
                                              alt="all"
                                            />
                                            all{" "}
                                          </span>
                                        </Link>
                                      </li>
                                    )}
                                    {categoryStripList.map(
                                      (subName, subIndex) => {
                                        const isActive =
                                          normalizeValue(
                                            selectedSubCategory || "",
                                          ) === normalizeValue(subName || "");
                                        return (
                                          <li
                                            key={subName}
                                            ref={(el) =>
                                              (categoryStripRefs.current[
                                                subIndex
                                              ] = el)
                                            }
                                            className={`nav-item${isActive ? " active" : ""}`}
                                          >
                                            <Link
                                              to="#"
                                              role="tab"
                                              tabIndex={0}
                                              className={`nav-link${isActive ? " active" : ""}`}
                                              aria-controls={`tab-${subIndex}`}
                                              aria-selected={isActive}
                                              id={`childTab-${activeFilterIndex}-${subIndex}`}
                                              onClick={(e) => {
                                                e.preventDefault();
                                                setSearchParams((prev) => {
                                                  const next =
                                                    new URLSearchParams(prev);
                                                  next.set(
                                                    "subCategory",
                                                    subName,
                                                  );
                                                  return next;
                                                });
                                                categoryStripRefs.current[
                                                  subIndex
                                                ]?.scrollIntoView({
                                                  behavior: "smooth",
                                                  block: "nearest",
                                                  inline: "center",
                                                });
                                              }}
                                              onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                  e.preventDefault();
                                                  setSearchParams((prev) => {
                                                    const next =
                                                      new URLSearchParams(prev);
                                                    next.set(
                                                      "subCategory",
                                                      subName,
                                                    );
                                                    return next;
                                                  });
                                                  categoryStripRefs.current[
                                                    subIndex
                                                  ]?.scrollIntoView({
                                                    behavior: "smooth",
                                                    block: "nearest",
                                                    inline: "center",
                                                  });
                                                }
                                              }}
                                            >
                                              <span />
                                              <span>
                                                <img
                                                  className="img-fluid"
                                                  src={`${SUBCATEGORY_ICON_BASE}/${slugify(
                                                    getCategoryDisplayLabel(
                                                      subName,
                                                    ),
                                                  )}.png`}
                                                  alt=""
                                                  onError={(e) => {
                                                    e.currentTarget.onerror =
                                                      null;
                                                    e.currentTarget.src = `${SUBCATEGORY_ICON_BASE}/others.png`;
                                                  }}
                                                />{" "}
                                                {getCategoryDisplayLabel(
                                                  subName,
                                                )}{" "}
                                              </span>
                                            </Link>
                                          </li>
                                        );
                                      },
                                    )}
                                  </ul>
                                  <div className="tab-content">
                                    <div className="csn_div">
                                      {loading && (
                                        <div className="w-100 text-center py-3">
                                          Loading games...
                                        </div>
                                      )}
                                      {displayedGames.map((game) => (
                                        <div
                                          key={
                                            game.gameId ||
                                            game.gameCode ||
                                            game.gameName
                                          }
                                          className="csn_thumb"
                                        >
                                          <img
                                            className="img-fluid ng-lazyloaded"
                                            src={game.urlThumb || ""}
                                            alt={game.gameName}
                                            onClick={() =>
                                              handleGameClick(game)
                                            }
                                          />
                                          <div className="casino-name">
                                            {game.gameName}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Casino;
